var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocationLinear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.587 18.878c.766-.61 1.531-1.298 2.244-2.05C16.82 14.728 18 12.565 18 10.5a6 6 0 1 0-12 0c0 2.065 1.18 4.227 3.17 6.328A21.866 21.866 0 0 0 12 19.329c.182-.134.379-.285.587-.45zM12 3a7.5 7.5 0 0 1 7.5 7.5c0 2.529-1.352 5.007-3.58 7.36a23.35 23.35 0 0 1-3.19 2.794c-.147.106-.254.18-.314.22a.75.75 0 0 1-.832 0 21.313 21.313 0 0 1-1.106-.822 23.35 23.35 0 0 1-2.397-2.192C5.85 15.507 4.5 13.029 4.5 10.5A7.5 7.5 0 0 1 12 3zm0 4.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM12 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    fill: "#2F3742",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationLinear);
export default __webpack_public_path__ + "static/media/icon-location-linear.014e7f35.svg";
export { ForwardRef as ReactComponent };